// extracted by mini-css-extract-plugin
export default {"FullNameFormatter__name":"FullNameFormatter_FullNameFormatter__name__0JZ3J","FullNameFormatter__initials":"FullNameFormatter_FullNameFormatter__initials__5DGAT"};